import React from 'react';
import { connect } from 'react-redux'
import { redirectTo } from './../../action/redirection'
import * as productsAction from '../../action/productsAction';
import * as cartProductDetailsAction from '../../action/cartProductDetailsAction';
import { Utils } from '../../util/utils';
import * as productDetailsAction from './../../action/productDetailsAction';
import ProductColor from './productColor';
import { withRouter } from 'react-router';
import { updateSCTags, getDTMInit } from './../../service/dtmTag';
import { getVZDLInit } from './../../service/vzdl';
import { catchJSException, checktime } from './../../service/logService'
import Modal from 'react-responsive-modal';
import { Pages } from '../../constants/actionType';
// import { withCookies } from 'react-cookie';
import ReactHtmlParser from 'react-html-parser'


class ProductsList extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            productsValueState: [],
            openFlag: false,
            outOfStock: false,
            quantityValue: false,
            signIn: false,
            fltFlag: true
        }
    }

    onCloseModal = () => {
        try {
            this.setState({ openFlag: false });
            // this.setState({ outOfStock: false, quantityValue: false });
        } catch (ex) {
            catchJSException('productsList', this.props.appState.visitId, 'onCloseModal', ex);
        }
    }

    outOfStock = (selectedItem) => {
        try {
            this.setState({
                openFlag: true,
                outOfStock: true,
                quantityValue: false

            })
        } catch (ex) {
            catchJSException('productsList', this.props.appState.visitId, 'outOfStock', ex);
        }
    }
    addToCartLog = ((pagestate) => {
        return {
            page: 'AddToCart',
            mount: (pagestate === 'Mount') && Date.now(),
            unmount: (pagestate === 'WillMount') && Date.now(),
            pageURL: window.location.href,
            visitid: this.props.appState.visitId || 'visit_id_not_created',
            noSSNCheck: false,
            apiFetched: (pagestate === 'ApiFetched') && Date.now()
        }
    })

    addToCart = (selectedItem) => {
        try {
            let Qty = "";
            let productName = selectedItem.name;
            let selectedCategoryName = this.props.categoriesState.categoriesExp.find(obj => obj.categoryId === selectedItem.categoryId).name
            let urlName = this.props.props ? this.props.props.match.params.pageName : this.props.match.params.pageName
            if (urlName === "all-accessories") {
                let scTagData = "cartadd_all accessories_".concat(productName);
                updateSCTags(scTagData);
            } else {
                let scTagData = "cartadd_" + selectedCategoryName + "_".concat(productName);
                updateSCTags(scTagData);
            }
            Qty = this.prodExistInCart(selectedItem);
            if (Qty !== -1) {
                this.doAddToCart(selectedItem, Qty);
            }
            else {
                this.setState({
                    openFlag: true,
                    quantityValue: true,
                    outOfStock: false

                })
            }

        } catch (ex) {
            catchJSException('productsList', this.props.appState.visitId, 'addToCart', ex);
        }
    }

    prodExistInCart = (productDetails, quantity =1) => {
        try {
          let machedObj = '';
          let Qty = quantity;
          let cartData = this.props.cartProduct ;
          cartData &&
            cartData.forEach((cartPdp) => {
              if (productDetails.productId === cartPdp.pppId && productDetails.itemId === cartPdp.itemId) {
                Qty += parseInt(cartPdp.qty, 10);
                machedObj = 'yes';
              }
            });
          if (machedObj !== '' && machedObj !== null) {
            //cart already has same product
            //Qty += parseInt(machedObj.qty, 10);
            if (Qty > parseInt(productDetails.maxQty, 10)) {
              //should not allow to add add more qty need to show popup saying exceeds limit
              Qty = -1;
            }
          }
          return Qty;
        } catch (ex) {
          catchJSException('productsList', this.props.appState.visitId, 'prodExistInCart', ex);
        }
    };

    doAddToCart = (selectedItem, Qty) => {
        try {
            var productInfo = {
                productId: selectedItem.productId,
                itemId: selectedItem.itemId,
                productType: "PPP",
                quantity: Qty,
                serviceType: "ACCESSORIES",
                status: "add",
                category: selectedItem.categoryId,
                addlInfo: [{ "key": "categoryName", "value": this.props.categoriesState.categoriesExp.find(obj => obj.categoryId === selectedItem.categoryId).name }, { "key": "signedIn", "value": this.props.categoriesState.isValidUser }],
                orderType: "",
                promoId: (selectedItem.promotion && selectedItem.promotion.crmmCode) ? selectedItem.promotion.crmmCode : "",
                mlpFlow : (this.props.appState && this.props.appState.mlpFlow) ? this.props.appState.mlpFlow : false,
                redemptionProductName : (this.props.appState && this.props.appState.mlpPDP) ? this.props.appState.mlpPDP : "",
                accessoryType: "vtp"
            }
            let request = JSON.stringify(productInfo);
            let validatePromise = productsAction.updateCart(request, this.props.appState.visitId, this.props.dispatch);
            Promise.all([validatePromise])
                .then(
                    showCart => {
                        cartProductDetailsAction.showCart(false, this.props.dispatch);
                        setTimeout(() => { cartProductDetailsAction.showCart(true, this.props.dispatch) }, 3000)
                        checktime(this.addToCartLog('Mount'));
                        let selectedCategoryName = this.props.categoriesState.categoriesExp.find(obj => obj.categoryId === selectedItem.categoryId).name
                        let categoryName = Utils.removeSpecialChars(selectedCategoryName);
                        let catName = ""
                        if (this.props.products && this.props.products.pageinfo && this.props.products.pageinfo.categoryName) {
                            catName = this.props.products.pageinfo.categoryName
                        }
                        let transactionData = {
                            visitId: this.props.appState.visitId
                        }
                        let txnData = {
                            total : this.props.cartData.total,
                            taxAmt : this.props.cartData.tax,
                            shippingZip : "",
                            shippingCharge : this.props.cartData.shippingcrg,
                            paymentType : "",
                            status : ""
                        }
                        getDTMInit("addToCartProdlist", "", "", true, "", this.props.cartProduct, categoryName, selectedItem.itemName, transactionData);
                        if (this.props.cartProduct && this.props.cartProduct.length === 1 && this.props.cartProduct[0].qty === "1") {
                            getVZDLInit(this.props.appState.visitId, catName, "", true, "cartadd_prodlist", "scOpen,scAdd",catName,"","",{cartData : this.props.cartProduct,currentlyselected : selectedItem.itemName,txnData : txnData});
                        } else {
                            getVZDLInit(this.props.appState.visitId, catName, "", true, "cartadd_prodlist", "scAdd",catName,"","",{cartData : this.props.cartProduct,currentlyselected : selectedItem.itemName,txnData : txnData});
                        }
                    }
                ).catch()
        } catch (ex) {
            catchJSException('productsList', this.props.appState.visitId, 'doAddToCart', ex);
        }
    }

    OnImageClick = ((selectedPrd) => {
        this.props.dispatch({ type: 'STORECOLORCLICK', value: false });
        try {

            let productName = selectedPrd.name;
            updateSCTags(productName);
            let selectedCategoryId = selectedPrd.categoryId;
            let selectedCategoryName = this.props.categoriesState.categoriesExp.find(obj => obj.categoryId === selectedCategoryId).name
            let categoryName = Utils.removeSpecialChars(selectedCategoryName);
            /*getDTMInit("accessoriesPdpCategories", categoryName, productName);*/
            let selectedPrds = Utils.removeSpecialChars(selectedPrd.seoKw)
            let request = {
                "categoryId": selectedPrd.categoryId,
                "productId": selectedPrd.productId,
                "skuId": selectedPrd.skuId,
            }
            this.props.categoriesState.categoriesExp.find((value, index) => {
                if (selectedPrd.categoryId === value.categoryId) {
                    categoryName = Utils.removeSpecialChars(value.name)
                    return categoryName
                }
                return "";
            })

            // let redirectURL = Pages.Category + categoryName + '/' + selectedPrds
            let redirectURL = Pages.Category + selectedPrds + "/";

            redirectTo(redirectURL, this.props.dispatch)
            this.props.dispatch({ type: 'STORECOLORCLICK', value: true });
            productDetailsAction.storeProductId(this.props.dispatch, request)
            // this.props.dispatch({ type: 'PAGEINFO', value: request })
        } catch (ex) {
            catchJSException('productsList', this.props.appState.visitId, 'OnImageClick', ex);
        }
    })
    componentWillReceiveProps(nextProps) {
        if (this.state.productsValueState !== nextProps.productsValue) {
            this.setState({
                productsValueState: nextProps.productsValue,
                fltFlag: nextProps.clrFlag
            });

        }
    }
    componentDidMount() {
        let categoryName = ""
        if (this.props.products && this.props.products.pageinfo && this.props.products.pageinfo.categoryName) {
            categoryName = this.props.products.pageinfo.categoryName
        }
        let transactionData = {
            visitId: this.props.appState.visitId
        }
        let txnData = {
            total : this.props.cartData.total,
            taxAmt : this.props.cartData.tax,
            shippingZip : "",
            shippingCharge : this.props.cartData.shippingcrg,
            paymentType : "",
            status : ""
        }
        let selectedCat = categoryName;
        let scTagData = "category: ".concat(selectedCat);
        updateSCTags(scTagData);
        getDTMInit("accessoriesCategories", categoryName, "", "", "", "", "", "", transactionData);
        getVZDLInit(this.props.appState.visitId, categoryName, "", "", "", "", categoryName,"","",{cartData : this.props.cartProduct,txnData : txnData});
    }

    colorSelectionCall = (groupId, productId, flag,btnId) => {
        if(btnId){          
            setTimeout(() => {
                document.getElementById(btnId).focus();
          }, 10);
        }
        try {
            this.setState({
                fltFlag: flag
            })
            this.state.productsValueState.map((groupExpitems, index) => {
                if (groupExpitems.groupId === groupId) {
                    groupExpitems.items.map((itemValue, index) => {
                        if (itemValue.productId === productId) {

                            groupExpitems.selectedProd = itemValue
                            this.setState(groupExpitems.selectedProd)
                            this.setState(this.state.productsValueState)
                            productsAction.productValue(this.state.productsValueState, this.props.dispatch);
                        }
                        return "";
                    })
                }
                return "";
            })
        } catch (ex) {
            catchJSException('productsList', this.props.appState.visitId, 'colorSelectionCall', ex);
        }
    }
    render() {
        let productsList = [];
        let addToCartBehaviour
        let domain = Utils.getDomainUrl();
        const { openFlag } = this.state;
        let productCount
        let zeroCountErrorMsg
        if (this.props.paginationState) {
            productCount = this.props.paginationState.productCount
            if (this.props.paginationState.zeroProductsMessage) {
                zeroCountErrorMsg = ReactHtmlParser(this.props.paginationState.zeroProductsMessage.description)
            }
        }
        if (this.props.productsValue) {
            this.setState({
                productsValueState: this.props.productsValue
            })
            if (this.state.productsValueState) {
                this.state.productsValueState.map((productsExpitems, index) => {
                    if (productsExpitems.selectedProd.addToCartBehaviour === "See Details") {
                        addToCartBehaviour = (<div className="tpgrid_box">
                            <button className="button" data-add-cart="" aria-label={"See details for" + productsExpitems.selectedProd.itemName} onClick={() => this.OnImageClick(productsExpitems.selectedProd)}>See Details</button>
                        </div>)
                    }
                    else {
                        addToCartBehaviour = (<div className="tpgrid_box">
                            {productsExpitems.selectedProd.outOfStock === true ?
                                <button className="button " aria-label = {productsExpitems.selectedProd.itemName + "is out of stock"} onClick={() => this.outOfStock(productsExpitems.selectedProd)}>Out of stock</button> :
                                <button className="button" data-add-cart="" aria-label = {"Add" + productsExpitems.selectedProd.itemName + "to cart"} onClick={() => this.addToCart(productsExpitems.selectedProd)}>Add to Cart</button>
                            }
                        </div>)

                    }
                    productsList.push(
                        <div key={productsExpitems.selectedProd.productId} className="tpgrid_item carousel_item mainShowCart" data-tpgrid-scale="" style={{ display: "" }}>
                            <div >
                                <div className="tpgrid_name-price ">
                                    <div onClick={() => this.OnImageClick(productsExpitems.selectedProd)}>
                                        <div className="tpgrid_top-rated discountTag">
                                            <div className="">
                                                {productsExpitems.selectedProd.promotion && productsExpitems.selectedProd.promotion.priceOff ? productsExpitems.selectedProd.promotion.viewPriceInCart ? " " : <span className="sr-only">Tag</span> : ""}
                                                {productsExpitems.selectedProd.promotion && productsExpitems.selectedProd.promotion.priceOff ? productsExpitems.selectedProd.promotion.viewPriceInCart ? " " : "Sale " + productsExpitems.selectedProd.promotion.priceOff : ""}
                                            </div> </div>

                                        <div className="tpgrid_placeholder">
                                            <a tabIndex="-1" className="disable-href" lid={productsExpitems.selectedProd.imagePath} href={Pages.Category + Utils.removeSpecialChars(productsExpitems.selectedProd.seoKw) + "/"}>
                                                <img src={Utils.getImagePath(productsExpitems.selectedProd.imagePath) } alt={productsExpitems.selectedProd.altText} />
                                            </a>
                                            {productsExpitems.selectedProd.outOfStock === true &&
                                                <div className="tpgrid_outofstock apex-book">
                                                    Out of stock but coming soon
                                        </div>}
                                        </div>
                                        <div className="tpgrid_product">
                                            <div className="tpgrid_product-name">
                                                <a className="disp_prod_link disable-href" href={Pages.Category + Utils.removeSpecialChars(productsExpitems.selectedProd.seoKw) + "/"} >{productsExpitems.selectedProd.itemName}</a>
                                            </div>
                                            {productsExpitems.selectedProd.promotion ?
                                                <div>
                                                    <div className="tpgrid_product-actual-price bold">Was <strike className="text-brand-1">${productsExpitems.selectedProd.actualPrice}</strike></div>
                                                    {productsExpitems.selectedProd.promotion.viewPriceInCart ? <div class="tpgrid_product-view">View Sale Price in Cart</div> : <div className="tpgrid_product-price">{"$" + productsExpitems.selectedProd.price} </div>}
                                                </div>
                                                : <div className="tpgrid_product-price">{"$" + productsExpitems.selectedProd.price} </div>}
                                            <div className="tpgrid_product-colors" data-grid-colors="" >
                                                <ProductColor colorSelection={this.colorSelectionCall} itemValue={productsExpitems.items} groupId={productsExpitems.groupId} selectedValue={productsExpitems.selectedProd} productColor={this.props.productColor.color} fltFlag={this.state.fltFlag} />
                                            </div>
                                        </div>
                                    </div>




                                </div>
                            </div>


                            <div id={productsExpitems.selectedProd.productId} className="tpgrid_detail-box padding-all-tiny showCart" >
                                {addToCartBehaviour}
                            </div>

                        </div>
                    )
                    return "";
                })
            }
        }
        return (
            <React.Fragment>
                <div className="w_tpgrid" data-page-content="1" >
                    <Modal open={openFlag} onClose={() => this.onCloseModal()} center focusTrapped={true}>
                        <div >
                            <div>
                                {this.state.outOfStock === true &&
                                    <div className="modal_header">
                                        <h4 class="tiny-padding-right-large medium-padding-right-zero">Item is out of stock</h4>
                                    </div>}
                            </div>

                            <div >
                                {this.state.quantityValue === true &&
                                    <div className="modal_header">
                                        <h4 className="margin-bottom-zero">Sorry!</h4>
                                    </div>}
                                {this.state.quantityValue === true &&

                                    <div className="modal_content" style={{ maxHeight: "534.5px", height: "207px" }}>
                                        <p className="products-description_details">
                                            There are limits on the quantity of each product you can add to your cart. You have reached that limit for this product.</p>
                                        <p className="products-description_details">
                                            Please continue shopping or check out with the items already in your cart.<br></br>
                                            &nbsp; </p>
                                        <p>
                                            &nbsp;</p></div>}
                            </div>

                            <div className="modal_footer">
                                <div class="support_ok right margin-bottom-medium">
                                    <button lid="ok" onClick={() => this.onCloseModal()} className="button no-focus-effect" tabindex="0" aria-label="Click here or press escape key to close the modal">Ok </button>
                                </div>
                            </div>
                        </div>
                    </Modal>
                    {productCount === 0 ? zeroCountErrorMsg : productsList}
                </div>
            </React.Fragment>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        appState: state.appVTP,
        cartData : state.cartProductDataVTP,
        cartProduct: state.cartProductDataVTP.cartProduct,
        categoriesState: state.categoriesVTP,
        products: state.productsVTP
    }
}
export default withRouter(connect(mapStateToProps)(ProductsList));
